import { makeStyles, Box, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AboutLoggingTooltip from 'src/components/AboutLoggingTooltip';
import { RootState } from 'src/store';
import { editBtnAgain } from 'src/store/modules/buttons';
// import { editRadius } from 'src/store/modules/imageUpload';

interface radiusProps {
  menuTitle: string;
  type: string;
  max: number;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1rem',
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },

  radiusWrapper: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem'
  },
  radius: {
    width: '1.25rem',
    height: '1.25rem',
    padding: '0.15625rem',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    border: '1.4px solid #dddddd',
    borderRadius: '50%'
  },
  radiusAct: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: '#000'
  },

  input: {
    height: '2.5rem',
    padding: '0.5rem',
    outline: 'none',
    overflow: 'hidden',

    '&:focus': {
      border: 0,
      outline: 'none'
    },

    border: '1px solid #dddddd'
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  }
}));

const EditBtnAgain: any = ({ menuTitle, type }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  var btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const [key, setKey] = useState(false);
  const handleKey = e => {
    if (e.key === 'Enter') setKey(true);
    else setKey(false);
  };
  const handleBtnAgain = e => {
    const textSplit = e.target.value.split('');
    if (
      textSplit[textSplit.length - 1] === '\\' ||
      textSplit[textSplit.length - 1] === '"'
    )
      return;
    const newBtnAgain = { [type]: e.target.value };
    dispatch(editBtnAgain({ ...btnAgain, ...newBtnAgain }));
  };

  const handleClickInput = (type: any) => {
    if (btnAgain?.type === type) {
      const newBtnAgain = JSON.parse(`{"type": "none"}`);
      dispatch(editBtnAgain({ ...btnAgain, ...newBtnAgain }));
    } else {
      // const newBtnAgain = JSON.parse(`{"type": "${type}"}`);
      const newBtnAgain = { type: type };

      dispatch(editBtnAgain({ ...btnAgain, ...newBtnAgain }));
    }
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            fontFamily: 'Archivo',
            fontSize: '0.875rem',
            fontWeight: 600,
            letterSpacing: '0.0175rem'
          }}
        >
          {/* {menuTitle} */}
          LOGGING
        </div>
        <AboutLoggingTooltip />
      </div>

      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}
      >
        <Box
          className={classes.radiusWrapper}
          onClick={() => handleClickInput('attribute')}
        >
          <Box className={classes.radius}>
            {btnAgain?.type === 'attribute' && (
              <Box className={classes.radiusAct}></Box>
            )}
          </Box>
          <span>Log Custom Attribute</span>
        </Box>
        {btnAgain?.type === 'attribute' && (
          <TextField
            className={classes.input}
            id="standard-multiline-flexible"
            //   multiline
            InputProps={{
              classes: {
                root: classes.inputRoot,
                input: classes.inputText
              },
              disableUnderline: true
            }}
            value={btnAgain?.[type]}
            onChange={handleBtnAgain}
            onKeyPress={handleKey}
          />
        )}

        <Box
          className={classes.radiusWrapper}
          onClick={() => handleClickInput('event')}
        >
          <Box className={classes.radius}>
            {btnAgain?.type === 'event' && (
              <Box className={classes.radiusAct}></Box>
            )}
          </Box>
          <span>Log Custom Event</span>
        </Box>
        {btnAgain?.type === 'event' && (
          <TextField
            className={classes.input}
            id="standard-multiline-flexible"
            //   multiline
            InputProps={{
              classes: {
                root: classes.inputRoot,
                input: classes.inputText
              },
              disableUnderline: true
            }}
            value={btnAgain?.[type]}
            onChange={handleBtnAgain}
            onKeyPress={handleKey}
          />
        )}
      </Box>
    </div>
  );
};
export default EditBtnAgain;
